'use strict';

/** @type {import('.')} */
module.exports = Object;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-object-atoms/index.js
// module id = 364
// module chunks = 0